




























import { Component, Vue } from 'vue-property-decorator';
import { noticedetel } from '@/utils/api';
import { noticeTime } from '@/config/utils';
@Component
export default class DictListView extends Vue {
  text: any = {};
  src1: String = require('../../image/placeholder1.png');
  mounted() {
    var id = this.$route.query.id;
    noticedetel(id).then(res => {
      if (res.status == 200) {
        this.text = {
          name: res.data.name,
          createdBy: res.data['createdBy'],
          publishTime:  noticeTime(res.data.publishTime),
          content: res.data.content
        };
      }
    });
  }
}
